import { FC } from "react";

import { Box, Button, Column } from "@hightouch/htui";

import { Schedule, VisualCronSchedule } from "./types";
import { VisualCronExpression } from "./visual-cron-expression";

interface Props {
  defaultTime: string;
  isDisabled: boolean;
  schedule: VisualCronSchedule;
  setSchedule: (schedule: Schedule) => void;
}

export const VisualCronScheduleConfiguration: FC<Props> = ({
  defaultTime,
  isDisabled,
  schedule,
  setSchedule,
}) => (
  <Column align="start" gap={8}>
    <Box display="grid" gap={8}>
      {schedule.schedule?.expressions?.length &&
        schedule.schedule.expressions.map((_expression, index) => (
          <VisualCronExpression
            key={index}
            index={index}
            isDisabled={isDisabled}
            schedule={schedule}
            setSchedule={setSchedule}
          />
        ))}
    </Box>
    <Button
      isDisabled={isDisabled}
      onClick={() => {
        setSchedule({
          ...schedule,
          schedule: {
            ...schedule.schedule,
            expressions: [
              ...(schedule.schedule?.expressions ?? []),
              { days: {}, time: defaultTime },
            ],
          },
        });
      }}
    >
      Add recurrence
    </Button>
  </Column>
);
